
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogJsonDialog extends Serenity.EntityDialog<LogJsonRow, any> {
        protected getFormKey() { return LogJsonForm.formKey; }
        protected getIdProperty() { return LogJsonRow.idProperty; }
        protected getLocalTextPrefix() { return LogJsonRow.localTextPrefix; }
        protected getNameProperty() { return LogJsonRow.nameProperty; }
        protected getService() { return LogJsonService.baseUrl; }
        protected getDeletePermission() { return LogJsonRow.deletePermission; }
        protected getInsertPermission() { return LogJsonRow.insertPermission; }
        protected getUpdatePermission() { return LogJsonRow.updatePermission; }

        protected form = new LogJsonForm(this.idPrefix);

    }
}